import { Customer } from '@eo-storefronts/eo-core'
import { Box, TextField, Typography } from '@mui/material'
import { ChangeEvent } from 'react'
import { useEoState } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { CUSTOMER_STATE } from '~/src/stores/customer'

const CheckoutInvoiceCompanyDetails = () => {
  const { t } = useTranslations()
  const [ customer, setCustomer ] = useEoState(CUSTOMER_STATE)

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCustomer((state: Customer | null) => {
      if (!state) {
        return null
      }

      return {
        ...state,
        [event.target.name]: event.target.value
      }
    })
  }

  if (!customer) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}
    >
      <Typography>{t('checkout.invoice.company_details')}</Typography>
      <TextField
        name='company'
        size='small'
        sx={{
          backgroundColor: 'container.main',
          color: 'container.contrastText'
        }}
        label={`${t('checkout.invoice.company_name')} *`}
        value={customer.company}
        error={customer.company === ''}
        onChange={handleOnChange}
      />
      <TextField
        name='invoice_reference'
        size='small'
        sx={{
          backgroundColor: 'container.main',
          color: 'container.contrastText'
        }}
        label={t('checkout.invoice.reference')}
        value={customer.invoice_reference}
        onChange={handleOnChange}
      />
      <TextField
        name='vat_number'
        size='small'
        sx={{
          backgroundColor: 'container.main',
          color: 'container.contrastText'
        }}
        label={`${t('checkout.invoice.vat_number')} *`}
        value={customer.vat_number}
        error={customer.vat_number === ''}
        onChange={handleOnChange}
      />
    </Box>
  )
}

export default CheckoutInvoiceCompanyDetails
